module.exports = __webpack_public_path__ + "static/media/Jermaime_1_Fitted Hijab.8bf865db.jpeg";